import { Button, Form, Input, Select } from 'antd';
import React, { useEffect } from 'react';
import { useModels } from './ModelStore';
import { useForm } from 'antd/es/form/Form';
import { useBrands } from '../Brands/BrandStore';

function Add(props) {
    let { createModel } = useModels()
    let { getBrands, brands } = useBrands()
    let [form] = useForm();
    useEffect(() => {
        getBrands()
    }, [])
    return (
        <Form form={form} layout="vertical" onFinish={createModel} encType="multipart/form-data">
            <Form.Item label="O'zbekcha nomi" name="nameuz" rules={[{ required: true, message: 'Please input your name!' }]}>
                <Input />
            </Form.Item>
            <Form.Item label="Ruscha nomi" name="nameru" rules={[{ required: true, message: 'Please input your description!' }]}>
                <Input />
            </Form.Item>
            <Form.Item label="Brand" name="brand_id">
                <Select options={brands.map(brand => ({ label: brand.nameuz, value: brand.id }))} showSearch optionFilterProp="label" />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Qo'shish</Button>
            </Form.Item>
        </Form>
    );
}

export default Add;